/**
 * The deploy lane (staging/sandbox vs production) is decided by the host the portal
 * is served from, mirroring the API's DEPLOYMENT_STAGE. There is no in-app environment switch.
 * `VITE_DEPLOYMENT_STAGE` can override hostname detection for unusual hosts.
 *
 * Hostnames that contain `sandbox` (e.g. apibas-sandbox.pepsa.co) are non-production —
 * without that, the wallet UI would take the live virtual-account / 9PSB path.
 */
const NON_PRODUCTION_HOST_MARKERS = [
  'staging',
  'sandbox',
  'localhost',
  '127.0.0.1',
] as const

export function isProductionLane(hostname?: string): boolean {
  const stage = import.meta.env?.VITE_DEPLOYMENT_STAGE as string | undefined
  if (stage) {
    const normalized = stage.trim().toLowerCase()
    return normalized === 'production' || normalized === 'prod'
  }
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase()
  return !NON_PRODUCTION_HOST_MARKERS.some((marker) => host.includes(marker))
}

export function deployLaneLabel(hostname?: string): string {
  if (isProductionLane(hostname)) return 'Production'
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase()
  if (host.includes('sandbox')) return 'Sandbox'
  return 'Staging'
}
